import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { CLASSROOMS_KEY } from '@teetsh/app/src/queries/classrooms/useClassrooms';
import { TAGS_KEY } from '@teetsh/app/src/queries/tags/useTags';
import { TagWithClassrooms } from '@teetsh/app/src/containers/MesAnneesScolaires/School/Tags/types';
import { useTranslation } from 'react-i18next';

function reorderTags({
  schoolyearId,
  schoolId,
  tagsIds,
}: {
  schoolyearId: string;
  schoolId: string;
  tagsIds: string[];
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/tags/reorder`;
  return request(requestURL, {
    method: 'PATCH',
    body: { tagsIds },
  });
}

interface Props {
  schoolyearId: string;
  schoolId: string;
}

export default function useReorderTags(props: Props) {
  const { schoolyearId, schoolId } = props;
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['schoolyearSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: (tagsIds: string[]) =>
      reorderTags({
        schoolyearId,
        schoolId,
        tagsIds,
      }),
    onMutate: tagsIds => {
      queryClient.setQueryData<TagWithClassrooms[]>(
        [schoolyearId, schoolId, TAGS_KEY],
        data =>
          tagsIds
            .map(tagId => (data || []).find(tt => tt.id === tagId))
            .filter(tt => tt) as TagWithClassrooms[],
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CLASSROOMS_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('schoolyearSettings:messages.tag.reorderError'),
      });
      queryClient.invalidateQueries({
        queryKey: [schoolyearId, schoolId, TAGS_KEY],
      });
    },
  });
  return mutateAsync;
}
